import { useEffect, useState } from 'react';

// Reads the browser's own connection hints (Network Information API, where supported).
// Nothing is sent anywhere — this only decides how much to download up front.
function read() {
  const c = typeof navigator !== 'undefined' ? (navigator.connection || navigator.mozConnection || navigator.webkitConnection) : null;
  const saveData = !!c?.saveData;
  const type = c?.effectiveType || '4g'; // unknown → assume a normal connection
  const slow = saveData || ['slow-2g', '2g', '3g'].includes(type);
  return { saveData, type, slow, fast: !slow && type === '4g' };
}

export const getNetwork = read;

export function useNetwork() {
  const [net, setNet] = useState(read);
  useEffect(() => {
    const c = navigator.connection;
    if (!c?.addEventListener) return undefined;
    const on = () => setNet(read());
    c.addEventListener('change', on);
    return () => c.removeEventListener('change', on);
  }, []);
  return net;
}

/** Run work when the browser is idle (or after a short delay where idle callbacks aren't supported). */
export function whenIdle(fn, timeout = 3000) {
  if (typeof window === 'undefined') return () => {};
  if ('requestIdleCallback' in window) {
    const id = window.requestIdleCallback(fn, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = setTimeout(fn, 1500);
  return () => clearTimeout(id);
}
